import { Component, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { SystemHealthService } from "../../services/system-health.service";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-service-unavailable",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./service-unavailable.component.html",
  styleUrl: "./service-unavailable.component.scss",
})
export class ServiceUnavailableComponent implements OnInit, OnDestroy {
  status: "failed" | "checking" = "failed";
  cooldown = 0;
  private cooldownInterval!: any;
  private readonly COOLDOWN_SECONDS = 180; 
  private readonly STORAGE_KEY = "HOME_COOLDOWN_TS";

  constructor(
    private router: Router,
    private systemHealth: SystemHealthService
  ) {}

  ngOnInit(): void {
    const last = localStorage.getItem(this.STORAGE_KEY);
    if (last) {
      const remaining =
        this.COOLDOWN_SECONDS - Math.floor((Date.now() - +last) / 1000);
      if (remaining > 0) {
        this.startCooldown(remaining);
      }
    }
  }

  goHome(): void {
    if (this.cooldown > 0) return;

    this.systemHealth.clear();
    this.router.navigateByUrl("/");

    localStorage.setItem(this.STORAGE_KEY, Date.now().toString());
    this.startCooldown(this.COOLDOWN_SECONDS);
  }

  private startCooldown(seconds: number) {
    this.cooldown = seconds;
    if (this.cooldownInterval) clearInterval(this.cooldownInterval); // Tránh trùng lặp interval
    this.cooldownInterval = setInterval(() => {
      this.cooldown--;
      if (this.cooldown <= 0) {
        clearInterval(this.cooldownInterval);
        localStorage.removeItem(this.STORAGE_KEY);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.cooldownInterval) clearInterval(this.cooldownInterval);
  }
}